export default ["M8 3a5 5 0 100 10A5 5 0 108 3z"];
